/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  updateAccountLabel: {
    id: 'PayPalComponents.Connect.ConnectView.Form.actions.UpdateAccount.label',
    defaultMessage: 'Update Account',
    description:
      'Label of the action used to update an already completed PayPal Connect account'
  },
  redirectLinkError: {
    id:
      'PayPalComponents.Connect.ConnectView.Form.actions.UpdateAccount.url.invalid',
    defaultMessage: 'The URL provided in the response was invalid.',
    description:
      'Message to display if the URL returned from the PayPal API call is invalid. This URL is used to redirect to the PayPal dashboard'
  }
});
